<template>
  <div id="app">
    <Nav/>
    <div id="page-wrap">
      <router-view/>
    </div> 
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'

export default {
  name: 'App',
  components: {
    Nav
  }
}
</script>

<style lang="scss">
@font-face {
    font-family: 'luthier';
    src: url('assets/fonts/luthier/luthier-regular-webfont.woff2') format('woff2'),
         url('assets/fonts/luthier/luthier-regular-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'luthierbold';
    src: url('assets/fonts/luthier/luthier-bold-webfont.woff2') format('woff2'),
         url('assets/fonts/luthier/luthier-bold-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;

}
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
body{
  background-color: #E4DDD3;
}
*{
  margin: 0;
  padding: 0;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4C7236;
  overflow: hidden;
  #page-wrap{
    transition: all 0.5s ease 0s;
  }
}

h1{
  font-family: 'luthierbold', Arial, sans-serif;
  color: #4C7236;
}
</style>
